import { Outlet, useOutletContext } from 'react-router-dom'

import { FormQuestionsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { NonPublishedQuestions } from 'modules/trainings/components/Revamp/Form/Questions/NonPublished'
import { PublishedQuestions } from 'modules/trainings/components/Revamp/Form/Questions/Published'
import {
  serializeQuestionnaireContent,
  serializeQuestionnaireResponseContent,
} from 'modules/trainings/lib/trainingFormQuestions'

import { TrainingFormContextType } from '../types'

const Questions = () => {
  const { setOpenSidepanel, openSidepanel, trainingForm } =
    useOutletContext<TrainingFormContextType>()

  const { data: questionsData } = useQuery(FormQuestionsDocument, {
    variables: { id: trainingForm.id },
  })
  const questionsRaw = questionsData?.forms?.form?.questions
  const questionnaire = questionsRaw?.questionnaire ?? []
  const questions = serializeQuestionnaireContent(questionnaire)
  const responses = serializeQuestionnaireResponseContent(questionnaire)
  return (
    <ResponsivePage.NestedBody>
      {trainingForm.status === 'active' ? (
        <PublishedQuestions currentPreview={responses} />
      ) : (
        <NonPublishedQuestions
          openSidepanel={openSidepanel}
          questions={questions}
          questionsId={questionsRaw?.id}
          questionnaire={questionnaire}
          setOpenSidepanel={setOpenSidepanel}
          trainingForm={trainingForm}
        />
      )}
      <Outlet context={{ trainingForm }} />
    </ResponsivePage.NestedBody>
  )
}
export default Questions
